import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { initObservability } from "./lib/observability.js";
import "./styles/index.css";

// Both Sentry and PostHog are inert when their env vars are unset; safe to
// call unconditionally here at module load.
initObservability();

const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined;
if (measurementId) {
  const dataLayer = ((window as unknown as { dataLayer?: unknown[] }).dataLayer = (window as unknown as { dataLayer?: unknown[] }).dataLayer || []);
  function gtag(..._args: unknown[]) {
    dataLayer.push(arguments);
  }
  (window as unknown as { gtag: (...a: unknown[]) => void }).gtag = gtag as (...a: unknown[]) => void;
  gtag("js", new Date());
  gtag("config", measurementId, { send_page_view: true });
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  document.head.appendChild(s);
}

const el = document.getElementById("root");
if (!el) throw new Error("missing #root");
createRoot(el).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
